module.exports = __webpack_public_path__ + "img/taobao-square.57404032.svg";